
export default function vendorsLine (){
    let vendorsLineWraps = document.querySelectorAll('[data-vendors-line="wrap"]');

    if(vendorsLineWraps.length){
        vendorsLineWraps.forEach(vendorsLineWrap =>{
            let newWidth = vendorsLineWrap.offsetWidth - window.innerWidth;
            vendorsLineWrap.style.width = newWidth + 'px';
        })
    }
}